// The ONLY file that may import from @tauri-apps/api.
// All imports are dynamic so this module tree-shakes correctly in web builds.

const isTauri = (): boolean => '__TAURI_INTERNALS__' in window;

export const platform = {
  async selectDirectory(): Promise<string | null> {
    if (!isTauri()) return null;
    const { invoke } = await import('@tauri-apps/api/core');
    return invoke<string>('select_directory');
  },

  async notify(title: string, body: string): Promise<void> {
    if (isTauri()) {
      const { invoke } = await import('@tauri-apps/api/core');
      return invoke('show_notification', { title, body });
    }
    if ('Notification' in window && Notification.permission === 'granted') {
      new Notification(title, { body });
    }
  },

  async getAppDataDir(): Promise<string> {
    if (!isTauri()) return '';
    const { invoke } = await import('@tauri-apps/api/core');
    return invoke<string>('get_app_data_dir');
  },

  async setWindowTitle(title: string): Promise<void> {
    if (isTauri()) {
      const { invoke } = await import('@tauri-apps/api/core');
      return invoke('set_window_title', { title });
    }
    document.title = title;
  },

  async checkForUpdates(): Promise<void> {
    if (!isTauri()) return;
    const { invoke } = await import('@tauri-apps/api/core');
    return invoke('check_for_updates');
  },
};
